import store from 'store';
import { callApi, Controller } from 'api/useApi';
import { Betreuer } from 'api/betreuer';
import { ArtikelGruppe, Land, Einheit, Lager, Lieferantenformular, Kalkulationsblatt } from 'api/lookup';
import { Branche } from 'api/branche';
import { AraRegelung } from 'api/araRegelung';
import { InteresseFuerProdukte } from 'api/interesseFuerProdukte';
import { ErweiterteSuche } from 'api/erweiterteSuche';
import { Produktgruppe } from 'api/produktgruppe';
import { Textbaustein } from 'api/textbaustein';
import { Skontodefinition } from 'api/skontodefinition';
import { Produzent } from 'api/produzent';
import { Maschinentype } from 'api/maschinentype';
import { ArtikelEigenschaft } from 'api/artikelEigenschaft';
import { Kontodefinition } from 'api/kontodefinition';
import {
    LookupsAction,
    LookupsActionType,
    BetreuerActionPayload,
    TextbausteineActionPayload,
    ArtikelGruppenActionPayload,
    BranchenActionPayload,
    InteresseFuerProdukteActionPayload,
    ErweiterteSuchenActionPayload,
    LaenderActionPayload,
    SkontodefinitionenActionPayload,
    EinheitenActionPayload,
    LagerActionPayload,
    AraRegelungenActionPayload,
    LieferantenformulareActionPayload,
    KalkulationsblaetterActionPayload,
    ArtikelEigenschaftenActionPayload,
    ProduktgruppenActionPayload,
    ProduzentenActionPayload,
    KontodefinitionenActionPayload,
    MaschinentypenActionPayload,
} from './types';

function requestBetreuerAction(): LookupsAction {
    return {
        type: LookupsActionType.REQUEST_BETREUER,
    };
}

function receiveBetreuerAction(payload: BetreuerActionPayload): LookupsAction {
    return {
        type: LookupsActionType.RECEIVE_BETREUER,
        payload,
    };
}

function requestTextbausteineAction(): LookupsAction {
    return {
        type: LookupsActionType.REQUEST_TEXTBAUSTEINE,
    };
}

function receiveTextbausteineAction(payload: TextbausteineActionPayload): LookupsAction {
    return {
        type: LookupsActionType.RECEIVE_TEXTBAUSTEINE,
        payload,
    };
}

/*
function requestArtikelAction(): LookupsAction {
    return {
        type: LookupsActionType.REQUEST_ARTIKEL,
    };
}

function receiveArtikelAction(payload: ArtikelActionPayload): LookupsAction {
    return {
        type: LookupsActionType.RECEIVE_ARTIKEL,
        payload,
    };
}
 */

function requestArtikelGruppenAction(): LookupsAction {
    return {
        type: LookupsActionType.REQUEST_ARTIKELGRUPPEN,
    };
}

function receiveArtikelGruppenAction(payload: ArtikelGruppenActionPayload): LookupsAction {
    return {
        type: LookupsActionType.RECEIVE_ARTIKELGRUPPEN,
        payload,
    };
}

/*
function requestArtikelDetailsAction(): LookupsAction {
    return {
        type: LookupsActionType.REQUEST_ARTIKELDETAILS,
    };
}

function receiveArtikelDetailsAction(payload: ArtikelDetailActionPayload): LookupsAction {
    return {
        type: LookupsActionType.RECEIVE_ARTIKELDETAILS,
        payload,
    };
}
*/

function requestBranchenAction(): LookupsAction {
    return {
        type: LookupsActionType.REQUEST_BRANCHEN,
    };
}

function receiveBranchenAction(payload: BranchenActionPayload): LookupsAction {
    return {
        type: LookupsActionType.RECEIVE_BRANCHEN,
        payload,
    };
}

function requestInteresseFuerProdukteAction(): LookupsAction {
    return {
        type: LookupsActionType.REQUEST_INTERESSEFUERPRODUKTE,
    };
}

function receiveInteresseFuerProdukteAction(payload: InteresseFuerProdukteActionPayload): LookupsAction {
    return {
        type: LookupsActionType.RECEIVE_INTERESSEFUERPRODUKTE,
        payload,
    };
}

function requestErweiterteSuchenAction(): LookupsAction {
    return {
        type: LookupsActionType.REQUEST_ERWEITERTESUCHEN,
    };
}

function receiveErweiterteSuchenAction(payload: ErweiterteSuchenActionPayload): LookupsAction {
    return {
        type: LookupsActionType.RECEIVE_ERWEITERTESUCHEN,
        payload,
    };
}

function requestLaenderAction(): LookupsAction {
    return {
        type: LookupsActionType.REQUEST_LAENDER,
    };
}

function receiveLaenderAction(payload: LaenderActionPayload): LookupsAction {
    return {
        type: LookupsActionType.RECEIVE_LAENDER,
        payload,
    };
}

function requestSkontodefinitionenAction(): LookupsAction {
    return {
        type: LookupsActionType.REQUEST_SKONTODEFINITIONEN,
    };
}

function receiveSkontodefinitionenAction(payload: SkontodefinitionenActionPayload): LookupsAction {
    return {
        type: LookupsActionType.RECEIVE_SKONTODEFINITIONEN,
        payload,
    };
}

function requestKontodefinitionenAction(): LookupsAction {
    return {
        type: LookupsActionType.REQUEST_KONTODEFINITIONEN,
    };
}

function receiveKontodefinitionenAction(payload: KontodefinitionenActionPayload): LookupsAction {
    return {
        type: LookupsActionType.RECEIVE_KONTODEFINITIONEN,
        payload,
    };
}

function requestEinheitenAction(): LookupsAction {
    return {
        type: LookupsActionType.REQUEST_EINHEITEN,
    };
}

function receiveEinheitenAction(payload: EinheitenActionPayload): LookupsAction {
    return {
        type: LookupsActionType.RECEIVE_EINHEITEN,
        payload,
    };
}

function requestLagerAction(): LookupsAction {
    return {
        type: LookupsActionType.REQUEST_LAGER,
    };
}

function receiveLagerAction(payload: LagerActionPayload): LookupsAction {
    return {
        type: LookupsActionType.RECEIVE_LAGER,
        payload,
    };
}

function requestAraRegelungenAction(): LookupsAction {
    return {
        type: LookupsActionType.REQUEST_ARA_REGELUNGEN,
    };
}

function receiveAraRegelungenAction(payload: AraRegelungenActionPayload): LookupsAction {
    return {
        type: LookupsActionType.RECEIVE_ARA_REGELUNGEN,
        payload,
    };
}

function requestLieferantenformulareAction(): LookupsAction {
    return {
        type: LookupsActionType.REQUEST_LIEFERANTENFORMULARE,
    };
}

function receiveLieferantenformulareAction(payload: LieferantenformulareActionPayload): LookupsAction {
    return {
        type: LookupsActionType.RECEIVE_LIEFERANTENFORMULARE,
        payload,
    };
}

function requestKalkulationsblaetterAction(): LookupsAction {
    return {
        type: LookupsActionType.REQUEST_KALKULATIONSBLAETTER,
    };
}

function receiveKalkulationsblaetterAction(payload: KalkulationsblaetterActionPayload): LookupsAction {
    return {
        type: LookupsActionType.RECEIVE_KALKULATIONSBLAETTER,
        payload,
    };
}

function requestArtikelEigenschaftenAction(): LookupsAction {
    return {
        type: LookupsActionType.REQUEST_ARTIKELEIGENSCHAFTEN,
    };
}

function receiveArtikelEigenschaftenAction(payload: ArtikelEigenschaftenActionPayload): LookupsAction {
    return {
        type: LookupsActionType.RECEIVE_ARTIKELEIGENSCHAFTEN,
        payload,
    };
}

function requestProduktgruppenAction(): LookupsAction {
    return {
        type: LookupsActionType.REQUEST_PRODUKTGRUPPEN,
    };
}

function receiveProduktgruppenAction(payload: ProduktgruppenActionPayload): LookupsAction {
    return {
        type: LookupsActionType.RECEIVE_PRODUKTGRUPPEN,
        payload,
    };
}

function requestProduzentenAction(): LookupsAction {
    return {
        type: LookupsActionType.REQUEST_PRODUZENTEN,
    };
}

function receiveProduzentenAction(payload: ProduzentenActionPayload): LookupsAction {
    return {
        type: LookupsActionType.RECEIVE_PRODUZENTEN,
        payload,
    };
}

function requestMaschinentypenAction(): LookupsAction {
    return {
        type: LookupsActionType.REQUEST_MASCHINENTYPEN,
    };
}

function receiveMaschinentypenAction(payload: MaschinentypenActionPayload): LookupsAction {
    return {
        type: LookupsActionType.RECEIVE_MASCHINENTYPEN,
        payload,
    };
}

export async function requestBetreuer(): Promise<void> {
    store.dispatch(requestBetreuerAction());

    const betreuerResult = await callApi<Betreuer[]>(Controller.lookup + '/betreuer', {});

    store.dispatch(
        receiveBetreuerAction({
            success: true,
            betreuer: betreuerResult,
        }),
    );
}

export async function requestTextbausteine(): Promise<void> {
    store.dispatch(requestTextbausteineAction());

    const textbausteineResult = await callApi<Textbaustein[]>(Controller.lookup + '/textbaustein', {});

    store.dispatch(
        receiveTextbausteineAction({
            success: true,
            textbausteine: textbausteineResult,
        }),
    );
}

/*
export async function requestArtikel(): Promise<void> {
    store.dispatch(requestArtikelAction());

    const artikelResult = await callApi<Artikel[]>(Controller.lookup + '/artikel', {});

    store.dispatch(
        receiveArtikelAction({
            success: true,
            artikel: artikelResult,
        }),
    );
}
 */

export async function requestArtikelGruppen(): Promise<void> {
    store.dispatch(requestArtikelGruppenAction());

    const artikelGruppenResult = await callApi<ArtikelGruppe[]>(Controller.lookup + '/artikelgruppe', {});

    store.dispatch(
        receiveArtikelGruppenAction({
            success: true,
            artikelGruppen: artikelGruppenResult,
        }),
    );
}

/*
export async function requestArtikelDetails(): Promise<void> {
    store.dispatch(requestArtikelDetailsAction());

    const artikelDetailsResult = await callApi<ArtikelDetail[]>(Controller.lookup + '/artikeldetail', {});

    store.dispatch(
        receiveArtikelDetailsAction({
            success: true,
            artikelDetails: artikelDetailsResult,
        }),
    );
}
 */

export async function requestBranchen(): Promise<void> {
    store.dispatch(requestBranchenAction());

    const branchenResult = await callApi<Branche[]>(Controller.lookup + '/branche', {});

    store.dispatch(
        receiveBranchenAction({
            success: true,
            branchen: branchenResult,
        }),
    );
}

export async function requestInteresseFuerProdukte(): Promise<void> {
    store.dispatch(requestInteresseFuerProdukteAction());

    const interesseFuerProdukteResult = await callApi<InteresseFuerProdukte[]>(
        Controller.lookup + '/interessefuerprodukte',
        {},
    );

    store.dispatch(
        receiveInteresseFuerProdukteAction({
            success: true,
            interesseFuerProdukte: interesseFuerProdukteResult,
        }),
    );
}

export async function requestErweiterteSuchen(): Promise<void> {
    store.dispatch(requestErweiterteSuchenAction());

    const erweiterteSuchenResult = await callApi<ErweiterteSuche[]>(Controller.lookup + '/erweitertesuche', {});

    store.dispatch(
        receiveErweiterteSuchenAction({
            success: true,
            erweiterteSuchen: erweiterteSuchenResult,
        }),
    );
}

export async function requestLaender(): Promise<void> {
    store.dispatch(requestLaenderAction());

    const laenderResult = await callApi<Land[]>(Controller.lookup + '/land', {});

    store.dispatch(
        receiveLaenderAction({
            success: true,
            laender: laenderResult,
        }),
    );
}

export async function requestSkontodefinitionen(): Promise<void> {
    store.dispatch(requestSkontodefinitionenAction());

    const skontodefinitionenResult = await callApi<Skontodefinition[]>(Controller.lookup + '/skontodefinition', {});

    store.dispatch(
        receiveSkontodefinitionenAction({
            success: true,
            skontodefinitionen: skontodefinitionenResult,
        }),
    );
}

export async function requestKontodefinitionen(): Promise<void> {
    store.dispatch(requestKontodefinitionenAction());

    const kontodefinitionenResult = await callApi<Kontodefinition[]>(Controller.lookup + '/kontodefinition', {});

    store.dispatch(
        receiveKontodefinitionenAction({
            success: true,
            kontodefinitionen: kontodefinitionenResult,
        }),
    );
}

export async function requestEinheiten(): Promise<void> {
    store.dispatch(requestEinheitenAction());

    const einheitenResult = await callApi<Einheit[]>(Controller.lookup + '/einheit', {});

    store.dispatch(
        receiveEinheitenAction({
            success: true,
            einheiten: einheitenResult,
        }),
    );
}

export async function requestLager(): Promise<void> {
    store.dispatch(requestLagerAction());

    const lagerResult = await callApi<Lager[]>(Controller.lookup + '/lager', {});

    store.dispatch(
        receiveLagerAction({
            success: true,
            lager: lagerResult,
        }),
    );
}

export async function requestAraRegelungen(): Promise<void> {
    store.dispatch(requestAraRegelungenAction());

    const araRegelungenResult = await callApi<AraRegelung[]>(Controller.lookup + '/araregelung', {});

    store.dispatch(
        receiveAraRegelungenAction({
            success: true,
            araRegelungen: araRegelungenResult,
        }),
    );
}

export async function requestLieferantenformulare(): Promise<void> {
    store.dispatch(requestLieferantenformulareAction());

    const lieferantenformulareResult = await callApi<Lieferantenformular[]>(
        Controller.lookup + '/lieferantenformular',
        {},
    );

    store.dispatch(
        receiveLieferantenformulareAction({
            success: true,
            lieferantenformulare: lieferantenformulareResult,
        }),
    );
}

export async function requestKalkulationsblaetter(): Promise<void> {
    store.dispatch(requestKalkulationsblaetterAction());

    const kalkulationsblaetterResult = await callApi<Kalkulationsblatt[]>(Controller.lookup + '/kalkulationsblatt', {});

    store.dispatch(
        receiveKalkulationsblaetterAction({
            success: true,
            kalkulationsblaetter: kalkulationsblaetterResult,
        }),
    );
}

export async function requestArtikelEigenschaften(): Promise<void> {
    store.dispatch(requestArtikelEigenschaftenAction());

    const artikelEigenschaftenResult = await callApi<ArtikelEigenschaft[]>(
        Controller.lookup + '/artikeleigenschaft',
        {},
    );

    store.dispatch(
        receiveArtikelEigenschaftenAction({
            success: true,
            artikelEigenschaften: artikelEigenschaftenResult,
        }),
    );
}

export async function requestProduktgruppen(): Promise<void> {
    store.dispatch(requestProduktgruppenAction());

    const produktgruppenResult = await callApi<Produktgruppe[]>(Controller.lookup + '/produktgruppe', {});

    store.dispatch(
        receiveProduktgruppenAction({
            success: true,
            produktgruppen: produktgruppenResult,
        }),
    );
}

export async function requestProduzenten(): Promise<void> {
    store.dispatch(requestProduzentenAction());

    const produzentenResult = await callApi<Produzent[]>(Controller.lookup + '/produzent', {});

    store.dispatch(
        receiveProduzentenAction({
            success: true,
            produzenten: produzentenResult,
        }),
    );
}

export async function requestMaschinentypen(): Promise<void> {
    store.dispatch(requestMaschinentypenAction());

    const maschinentypenResult = await callApi<Maschinentype[]>(Controller.lookup + '/maschinentype', {});

    store.dispatch(
        receiveMaschinentypenAction({
            success: true,
            maschinentypen: maschinentypenResult,
        }),
    );
}

function finishLoadingAction(): LookupsAction {
    return {
        type: LookupsActionType.FINISH_LOADING,
    };
}

export function finishLoading(): void {
    store.dispatch(finishLoadingAction());
}

export function lookupsInitialize(): void {
    requestBetreuer().then();
    requestTextbausteine().then();
    // requestArtikel().then();
    requestArtikelGruppen().then();
    // requestArtikelDetails().then();
    requestBranchen().then();
    requestInteresseFuerProdukte().then();
    requestErweiterteSuchen().then();
    requestLaender().then();
    requestSkontodefinitionen().then();
    requestKontodefinitionen().then();
    requestEinheiten().then();
    requestLager().then();
    requestAraRegelungen().then();
    requestLieferantenformulare().then();
    requestKalkulationsblaetter().then();
    requestArtikelEigenschaften().then();
    requestProduktgruppen().then();
    requestProduzenten().then();
    requestMaschinentypen().then();
}
